<template>
  <smartInputView :customParams="{customData: params.props.customParams, data: params.data}"
                  :viewMode="params.props.viewMode || 'text'"
                  :linkText="params.props.linkText || ''"
                  :noCopy="params.props.noCopy || false"
                  :noEdit="params.props.noEdit || false"
                  :inputValue="this.params.data[this.params.props.fieldName]"
                  :saveAction="this.params.props.saveAction"
                  :editContainerStyle="params.props.editContainerStyle" :fieldName="params.props.fieldName"
                  :inputWidth="params.props.inputWidth || '200px'"></smartInputView>
</template>

<script>
export default {
  components: {
    smartInputView: () => import("@/components/smart-input-view/View")
  }
}
</script>
